import { INPUT_TYPES } from '../utils/constants.js';
import { default as GALLERY_CONSTS } from '../../common/constants/index.js';
import { createOptions } from '../utils/utils.js';
import optionsMap from '../../core/helpers/optionsMap.js';
export default {
    title: 'Loading Placeholder',
    description: `Determines what is shown until the image is loaded.`,
    isRelevant: () => true,
    isRelevantDescription: 'Always relevant.',
    get options() {
        return createOptions(optionsMap.behaviourParams.item.content.loader);
    },
    type: INPUT_TYPES.OPTIONS,
    default: GALLERY_CONSTS[optionsMap.behaviourParams.item.content.loader].BLUR,
};
//# sourceMappingURL=behaviourParams_item_content_loader.js.map